import React, { useState } from 'react';
import { CalendarIcon, BellIcon, MapPinIcon, UsersIcon, DropletIcon, MountainIcon, TentIcon, LifeBuoyIcon, CompassIcon, FilterIcon, ChevronRightIcon } from 'lucide-react';
import Header from '../components/Header';
// Genereer activiteiten voor 4 dagen
const generateActivities = () => {
  const today = new Date();
  const activities = [];
  const categories = ['kids', 'sportief', 'rustig', 'avond', 'iedereen'];
  const titles = ['Kinderclub', 'Vlottenbouwen', 'Kampvuur', 'Yoga bij de rivier', 'Kanovaren', 'Mountainbiken', 'Bushcraft workshop', 'Speleologie', 'Boogschieten', 'Wandeltocht', 'Filmavond', 'Spelletjesavond', 'Natuurwandeling', 'Zwembadspellen', 'Klimmen', 'Shoot-out games'];
  const locations = ['Speeltuin', 'Rivier de Amblève', 'Centrale vuurplaats', 'Ligweide', 'Receptie (startpunt)', 'Bos naast camping', 'Sportterrein', 'Zwembad', 'Recreatieruimte', 'Panoramaterras'];
  // Genereer 3-6 activiteiten per dag voor 4 dagen
  for (let day = 0; day < 4; day++) {
    const date = new Date(today);
    date.setDate(today.getDate() + day);
    const formattedDate = date.toLocaleDateString('nl-NL', {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });
    const dayActivities = [];
    const numActivities = Math.floor(Math.random() * 4) + 3; // 3-6 activiteiten
    for (let i = 0; i < numActivities; i++) {
      const hour = Math.floor(Math.random() * 12) + 9; // 9-20 uur
      const title = titles[Math.floor(Math.random() * titles.length)];
      const category = categories[Math.floor(Math.random() * categories.length)];
      dayActivities.push({
        id: `${day}-${i}`,
        title,
        time: `${hour < 10 ? '0' + hour : hour}:00`,
        location: locations[Math.floor(Math.random() * locations.length)],
        category,
        description: generateDescription(title, category)
      });
    }
    // Sorteer activiteiten op tijd
    dayActivities.sort((a, b) => {
      return parseInt(a.time.split(':')[0]) - parseInt(b.time.split(':')[0]);
    });
    activities.push({
      date: formattedDate,
      activities: dayActivities
    });
  }
  return activities;
};
// Genereer beschrijvingen voor activiteiten
const generateDescription = (title, category) => {
  const descriptions = {
    Kinderclub: 'Knutselen, spelletjes en plezier voor kinderen van 4-12 jaar.',
    Vlottenbouwen: 'Bouw je eigen vlot en vaar ermee op de rivier. Voor alle leeftijden.',
    Kampvuur: 'Gezellig samenkomen bij het kampvuur met marshmallows en muziek.',
    'Yoga bij de rivier': 'Ontspannende yoga-sessie voor beginners en gevorderden.',
    Kanovaren: 'Kanotocht op de rivier, geschikt voor beginners en gevorderden.',
    Mountainbiken: 'Begeleide mountainbiketocht door de Ardennen, verschillende moeilijkheidsgraden.',
    'Bushcraft workshop': 'Leer overleven in de natuur: vuur maken, schuilplaats bouwen en meer.',
    Speleologie: 'Ontdek de grotten in de omgeving onder begeleiding van een expert.',
    Boogschieten: 'Leer de basis van boogschieten onder begeleiding van een instructeur.',
    Wandeltocht: 'Begeleide wandeling door de prachtige omgeving van de Ardennen.',
    Filmavond: 'Gezellige filmavond met popcorn in de recreatieruimte.',
    Spelletjesavond: 'Bordspellen en kaartspellen voor het hele gezin.',
    Natuurwandeling: 'Ontdek de lokale flora en fauna met onze natuurgids.',
    Zwembadspellen: 'Waterspellen en competities in het zwembad voor alle leeftijden.',
    Klimmen: 'Klimmuur en touwenparcours voor beginners en gevorderden.',
    'Shoot-out games': 'Spannende teamspellen in het bos met laserguns.'
  };
  return descriptions[title] || `${title} voor ${category === 'kids' ? 'kinderen' : 'alle kampeerders'}.`;
};
const Activities = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [activitiesData] = useState(generateActivities());
  const [activeDay, setActiveDay] = useState(0);
  // Filter activiteiten op basis van categorie
  const filteredActivities = activeFilter === 'all' ? activitiesData[activeDay].activities : activitiesData[activeDay].activities.filter(activity => activity.category === activeFilter);
  return <div className="flex flex-col min-h-full bg-gray-50" data-id="element-58">
      <Header title="Activiteiten" showBackButton data-id="element-59" />
      <div className="p-4" data-id="element-60">
        <div className="flex items-center justify-between mb-4" data-id="element-61">
          <div className="flex items-center" data-id="element-62">
            <CalendarIcon size={20} className="text-[#f9b30f] mr-2" data-id="element-63" />
            <h2 className="text-lg font-bold" data-id="element-64">Activiteitenkalender</h2>
          </div>
          <button className="flex items-center text-sm text-gray-600" data-id="element-65">
            <BellIcon size={16} className="mr-1" data-id="element-66" />
            Meldingen
          </button>
        </div>
        <div className="flex space-x-2 overflow-x-auto pb-2 mb-4" data-id="element-67">
          {activitiesData.map((dayData, index) => <button key={index} className={`py-2 px-4 rounded-lg ${activeDay === index ? 'bg-[#f9b30f] text-black' : 'bg-white text-gray-600 border border-gray-200'}`} onClick={() => setActiveDay(index)} data-id="element-68">
              <div className="text-sm whitespace-nowrap" data-id="element-69">
                {index === 0 ? 'Vandaag' : index === 1 ? 'Morgen' : dayData.date.split(' ')[0]}
              </div>
              <div className="text-xs whitespace-nowrap" data-id="element-70">
                {dayData.date.split(' ').slice(1).join(' ')}
              </div>
            </button>)}
        </div>
        <div className="flex space-x-2 overflow-x-auto pb-2 mb-4" data-id="element-71">
          <FilterButton label="Alles" active={activeFilter === 'all'} onClick={() => setActiveFilter('all')} data-id="element-72" />
          <FilterButton label="Kids" active={activeFilter === 'kids'} onClick={() => setActiveFilter('kids')} data-id="element-73" />
          <FilterButton label="Sportief" active={activeFilter === 'sportief'} onClick={() => setActiveFilter('sportief')} data-id="element-74" />
          <FilterButton label="Avond" active={activeFilter === 'avond'} onClick={() => setActiveFilter('avond')} data-id="element-75" />
          <FilterButton label="Rustig" active={activeFilter === 'rustig'} onClick={() => setActiveFilter('rustig')} data-id="element-76" />
          <FilterButton label="Voor iedereen" active={activeFilter === 'iedereen'} onClick={() => setActiveFilter('iedereen')} data-id="element-77" />
        </div>
        <div className="space-y-4" data-id="element-78">
          {filteredActivities.length > 0 ? filteredActivities.map(activity => <ActivityCard key={activity.id} activity={activity} data-id="element-79" />) : <div className="bg-white rounded-lg shadow-sm p-4 text-center" data-id="element-80">
              <p className="text-gray-600" data-id="element-81">
                Geen activiteiten gevonden voor deze filter.
              </p>
              <button className="mt-2 text-[#f9b30f] font-medium" onClick={() => setActiveFilter('all')} data-id="element-82">
                Toon alle activiteiten
              </button>
            </div>}
        </div>
        <div className="mt-6 bg-white rounded-lg shadow-sm p-4" data-id="element-83">
          <h3 className="font-bold mb-3" data-id="element-84">Outdoor Activiteiten</h3>
          <p className="text-sm text-gray-600 mb-3" data-id="element-85">
            Naast onze dagelijkse activiteiten bieden we ook verschillende
            outdoor avonturen aan. Vraag bij de receptie naar beschikbaarheid en
            prijzen.
          </p>
          <div className="grid grid-cols-2 gap-3" data-id="element-86">
            <OutdoorActivity icon={<LifeBuoyIcon size={20} data-id="element-88" />} title="Kanovaren" data-id="element-87" />
            <OutdoorActivity icon={<MountainIcon size={20} data-id="element-90" />} title="Mountainbiken" data-id="element-89" />
            <OutdoorActivity icon={<TentIcon size={20} data-id="element-92" />} title="Bushcraft" data-id="element-91" />
            <OutdoorActivity icon={<DropletIcon size={20} data-id="element-94" />} title="Vlottenbouwen" data-id="element-93" />
            <OutdoorActivity icon={<CompassIcon size={20} data-id="element-96" />} title="Shoot-out games" data-id="element-95" />
            <OutdoorActivity icon={<MountainIcon size={20} data-id="element-98" />} title="Speleologie" data-id="element-97" />
          </div>
        </div>
      </div>
    </div>;
};
const FilterButton = ({
  label,
  active,
  onClick
}) => {
  return <button className={`py-1 px-3 rounded-full text-sm whitespace-nowrap ${active ? 'bg-[#f9b30f] text-black' : 'bg-white text-gray-600 border border-gray-200'}`} onClick={onClick} data-id="element-99">
      {label}
    </button>;
};
const ActivityCard = ({
  activity
}) => {
  const [expanded, setExpanded] = useState(false);
  return <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-100">
      <div className="flex justify-between items-start" data-id="element-101">
        <div data-id="element-102">
          <h3 className="font-bold" data-id="element-103">{activity.title}</h3>
          <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-104">
            <span className="mr-3" data-id="element-105">{activity.time}</span>
            <div className="flex items-center" data-id="element-106">
              <MapPinIcon size={14} className="mr-1" data-id="element-107" />
              {activity.location}
            </div>
          </div>
        </div>
        <span className={`text-xs py-1 px-2 rounded-full ${activity.category === 'kids' ? 'bg-blue-100 text-blue-800' : activity.category === 'sportief' ? 'bg-green-100 text-green-800' : activity.category === 'rustig' ? 'bg-purple-100 text-purple-800' : activity.category === 'avond' ? 'bg-amber-100 text-amber-800' : 'bg-orange-100 text-orange-800'}`} data-id="element-108">
          {activity.category === 'kids' ? 'Kids' : activity.category === 'sportief' ? 'Sportief' : activity.category === 'rustig' ? 'Rustig' : activity.category === 'avond' ? 'Avond' : 'Voor iedereen'}
        </span>
      </div>
      <p className="text-sm text-gray-600 mt-2" data-id="element-109">{activity.description}</p>
      {expanded && <div className="mt-3 pt-3 border-t border-gray-100" data-id="element-110">
          <div className="text-sm space-y-2" data-id="element-111">
            <div className="flex items-start" data-id="element-112">
              <UsersIcon size={16} className="text-[#f9b30f] mr-2 mt-0.5" data-id="element-113" />
              <div data-id="element-114">
                <p className="font-medium" data-id="element-115">Deelnemers</p>
                <p className="text-gray-600" data-id="element-116">
                  {activity.category === 'kids' ? 'Kinderen van 4-12 jaar' : activity.category === 'sportief' ? 'Vanaf 12 jaar, goede conditie aanbevolen' : 'Alle leeftijden welkom'}
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-117">
              <MapPinIcon size={16} className="text-[#f9b30f] mr-2 mt-0.5" data-id="element-118" />
              <div data-id="element-119">
                <p className="font-medium" data-id="element-120">Verzamelpunt</p>
                <p className="text-gray-600" data-id="element-121">
                  {activity.location === 'Receptie (startpunt)' ? 'Bij de receptie, 10 minuten voor aanvang' : `Bij ${activity.location}, 5 minuten voor aanvang`}
                </p>
              </div>
            </div>
          </div>
        </div>}
      <div className="flex mt-3" data-id="element-122">
        <button className="text-xs text-[#f9b30f] mr-auto flex items-center" onClick={() => setExpanded(!expanded)} data-id="element-123">
          {expanded ? 'Minder info' : 'Meer info'}
          <ChevronRightIcon size={14} className={`ml-1 transform ${expanded ? 'rotate-90' : ''}`} data-id="element-124" />
        </button>
        <button className="bg-[#f9b30f]/10 text-black py-1.5 px-3 rounded-lg text-sm font-medium" data-id="element-125">
          Deelnemen
        </button>
      </div>
    </div>;
};
const OutdoorActivity = ({
  icon,
  title
}) => {
  return <div className="flex items-center bg-[#f9b30f]/5 p-2 rounded-lg" data-id="element-126">
      <div className="text-[#f9b30f] mr-2" data-id="element-127">{icon}</div>
      <span className="text-sm font-medium" data-id="element-128">{title}</span>
    </div>;
};
export default Activities;